/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '../../components/index';

// const ModalTempoRO = (props) => {
class ModalTempoRO extends Component {
  constructor() {
    super();
    this.state = {};
  }
    montaAlerta = alerta => (
      <div style={{ 'text-align': 'justify', 'font-weight': '300' }}>
        {alerta.descricao}
      </div>
    );

    montaListaAlertas = () => {
      const listaRelacoes = [];
      this.props.alertas.forEach((alerta) => {
        listaRelacoes
          .push(this.montaAlerta(alerta));
      });
      return listaRelacoes;
    };

    montaModalContent = () => (
      <React.Fragment>
        {this.montaListaAlertas()}
      </React.Fragment>
    );

    modalFooter = () => {
      return (
        <React.Fragment>
          <div className="right">
            <Button
              title="Cancelar"
              onClick={this.props.handleModal}
              hint="Cancelar"
            />
            <Button
              className="dtp-primary"
              title="Aceitar"
              onClick={this.props.aceitar}
            />
            </div>
        </React.Fragment>
      );
    };
 

    handleClose = () => {
      this.setState(this.props.handleModal);
    };
    render() {
      return (
        <Modal
          {...this.props}
          alert
          alertType="warning"
          conteudomodal={this.montaModalContent()}
          conteudofooter={this.modalFooter()}
          onHide={this.handleClose}
          showTitle
          size={this.props.tamanho ? this.props.tamanho : 'lg'}
          title={this.props.labelTitulo ? this.props.labelTitulo : 'Confirma a ação?'}
          showModal
        />
      );
    }
}

ModalTempoRO.propTypes = {
  handleModal: PropTypes.func.isRequired,
  aceitar: PropTypes.func.isRequired,
  alertas: PropTypes.arrayOf({ descricao: PropTypes.string }).isRequired,
  labelTitulo: PropTypes.string.isRequired,
  esconderBotaoCancelar: PropTypes.bool.isRequired,
  tamanho: PropTypes.string.isRequired,
};

export default ModalTempoRO;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalTempoRO.jsx